// extracted by mini-css-extract-plugin
export default {"bodyMainText":"logoConfiguration_bodyMainText__Q9SP4","dividerLine":"logoConfiguration_dividerLine__m6AnW","navigateBtnCol":"logoConfiguration_navigateBtnCol__jnqzv"};